import React, { ReactNode } from 'react';

import { ChakraProvider, createStandaloneToast } from '@chakra-ui/react';
import { customTheme } from 'theme';

const { ToastContainer } = createStandaloneToast();

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps) => (
  <ChakraProvider theme={customTheme}>
    {children}
    <ToastContainer />
  </ChakraProvider>
);
